import { createAction } from 'redux-actions';
import { ILoginActionData } from '../interfaces';

export enum AuthActionTypes {
  LOGIN_REQUEST = 'Request login user!',
  LOGIN_SUCCESS = 'Login Successfully!',
  LOGIN_FAILURE = 'Login Failed',
  FORGOT_PASSWORD_REQUEST = 'Request forgot password',
  FORGOT_PASSWORD_SUCCESS = 'Email sent Successfully!',
  FORGOT_PASSWORD_FAILURE = 'Failed',
  LINK_VERIFICATION_REQUEST = 'Link verification request',
  LINK_VERIFICATION_SUCCESS = 'Link verified successfully',
  LINK_VERIFICATION_FAILURE = 'Link verification failed',
  RESET_PASSWORD_REQUEST = 'Request for reset password',
  RESET_PASSWORD_SUCCESS = 'Password reset successfully',
  RESET_PASSWORD_FAILURE = 'Failes password reset request',
  LOGOUT_REQUEST = 'Logout Started!',
}

// Login Actions
export const LoginRequest = createAction<ILoginActionData>(
  AuthActionTypes.LOGIN_REQUEST,
);

export const LoginSuccess = createAction(AuthActionTypes.LOGIN_SUCCESS);
export const LoginFailed = createAction(AuthActionTypes.LOGIN_FAILURE);

// Forgot Password Actions
export const ForgotPasswordRequest = createAction<{ email: string }>(
  AuthActionTypes.FORGOT_PASSWORD_REQUEST,
);

export const ForgotPasswordSuccess = createAction(
  AuthActionTypes.FORGOT_PASSWORD_SUCCESS,
);
export const ForgotPasswordFailure = createAction(
  AuthActionTypes.FORGOT_PASSWORD_FAILURE,
);

// Link Verification
export const LinkVerificationRequest = createAction(
  AuthActionTypes.LINK_VERIFICATION_REQUEST,
);
export const LinkVerificationSuccess = createAction(
  AuthActionTypes.LINK_VERIFICATION_SUCCESS,
);
export const LinkVerificationFailure = createAction(
  AuthActionTypes.LINK_VERIFICATION_FAILURE,
);

// Reset Password Actions
export const ResetPasswordRequest = createAction(
  AuthActionTypes.RESET_PASSWORD_REQUEST,
);
export const ResetPasswordSuccess = createAction(
  AuthActionTypes.RESET_PASSWORD_SUCCESS,
);
export const ResetPasswordFailure = createAction(
  AuthActionTypes.RESET_PASSWORD_FAILURE,
);

export const LogOutRequest = createAction(AuthActionTypes.LOGOUT_REQUEST);
